export default "__VITE_ASSET__BqiKQLQm__"